import styled, {css} from 'styled-components';

const primeColor = '#135CA9';
// const secondaryColor = '#777';
const navigationDefault = '#757575';
const dayHover = '#f0f0f0';
const borderRadius = '0.5714285714285714rem';
const innerBorderRadius = '1.5714285714285714rem';

const dayWidth = '2.2857142857142856rem';
const daySideMargin = '0.14285714285714285rem';

export const StyledDatepicker = styled.div`
  text-align: center;
  align-self: flex-start;
  position: relative;
  min-width: 7.4rem;
  
  .ui.icon.button.simple, .react-datepicker__close-icon {
    position: absolute;
    left: auto;
    right: 2px;
    top: 0;
    border: 0;
    background: rgba(0,0,0,0);
  }
  
  &.disabled {
    cursor: default;
    pointer-events: none;
    opacity: 1;

    .react-datepicker-popper {
      display: none;
    }
  }

  .react-datepicker {
    vertical-align: top;
    background-color: white;
  }

  .react-datepicker__input-container > input {
    width: 100%;
    max-width: 100%;
    margin: 0;
    flex: 1 0 auto;
    outline: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    font-family: "ClearSans", Arial, sans-serif;
    background: #FFFFFF;
    border: 1px solid #aaa;
    color: rgba(0, 0, 0, 0.87);
    border-radius: ${borderRadius};
    transition: box-shadow 0.1s ease, border-color 0.1s ease;
    box-shadow: none;

    line-height: 1.28571429rem;
    padding: 0.6428571428571429rem;
    padding-right: 2.5714285714rem;

    &:hover,
    &:focus {
      border-color: ${primeColor};
      background: #FFFFFF;
      color: rgba(0, 0, 0, 0.8);
      box-shadow: none;
    }
  }

  .react-datepicker-wrapper {
    display: block !important;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker-popper {
    z-index: 1001;
  }

  .react-datepicker__close-icon {
    height: unset;
    width: 1.2857142857142858rem;
    right: 0.5rem;
    top: 0;
    bottom: 0;
    display: inline-flex;
    align-items: center;
  }

  .react-datepicker__close-icon::after {
    background-color: transparent;
    color: #333;
    font-size: 1.3em;
    height: unset;
    width: unset;
    line-height: unset;
    margin: 0;
    padding: 0;
    position: inherit;
    font-weight: bold;
    text-align: center;
    bottom: unset;
    right: unset;
  }

  .react-datepicker__close-icon:hover::after {
    color: ${primeColor};
  }

  .react-datepicker {
    border-radius: ${borderRadius};
    border: 1px solid ${primeColor};
    font-size: 0.8571428571428571rem;
    line-height: 0.8571428571428571rem;
  }

  .react-datepicker__month {
    cursor: pointer;
    padding: 10px;
  }

  &.datepicker-container--with-time {
    .react-datepicker {
      min-width: 24rem;
    }

    .react-datepicker__time-container {
      &,
      .react-datepicker__time-box {
        width: 4.642857142857143rem;
      }
    }
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header {
    font-size: 1rem;
    line-height: 1rem;
    font-weight: normal;
  }

  .react-datepicker__header {
    background: #fff;
    border-top-left-radius: ${innerBorderRadius};
    border-top-right-radius: ${innerBorderRadius};
    padding-top: 17px;
  }

  .react-datepicker__current-month,
  .react-datepicker__header__dropdown,
  .react-datepicker__header__dropdown--scroll,
  .react-datepicker__day-names,
  .react-datepicker__week {
    display: flex;
    justify-content: center;
  }

  &.with-month-year-dropdowns {
    .react-datepicker__current-month {
      display: none;
    }

    .react-datepicker__header__dropdown {
      padding: 4px 2.5rem 10px;
      gap: 6px;
    }

    .react-datepicker__month-dropdown-container,
    .react-datepicker__year-dropdown-container {
      margin: 0;
    }

    .react-datepicker__month-select,
    .react-datepicker__year-select {
      appearance: auto;
      border: 1px solid #c9d6e5;
      border-radius: 4px;
      background: #fff;
      color: ${navigationDefault};
      font-size: 13px;
      font-weight: 600;
      line-height: 1.2;
      padding: 2px 4px;
      max-width: 7.5rem;
      cursor: pointer;

      &:focus {
        outline: none;
        border-color: ${primeColor};
      }
    }

    .react-datepicker__navigation {
      top: 22px;
    }
  }

  .react-datepicker__week {
    margin-bottom: 0.2857142857142857rem;
  }

  .react-datepicker__time-container {
    border-color: ${primeColor};
    border-bottom-right-radius: 1.35rem;
    border-top-right-radius: 1.35rem;
    overflow: hidden;
  }

  .react-datepicker__current-month {
    text-transform: capitalize;
    padding: 5px 3rem 10px;
    color: ${navigationDefault};
    font-weight: 700;
    font-size: 14px;
  }

  .react-datepicker__navigation {
    position: absolute;
    border: 2px solid ${navigationDefault};
    transform: rotate(-45deg);
    width: 0.5714285714285714rem;
    height: 0.5714285714285714rem;
    top: 26px;
    background-color: rgba(0,0,0,0);

    &:hover {
      border-color: ${primeColor};
    }

    &:focus {
      outline: none;
    }

    .react-datepicker__navigation-icon {
      visibility: hidden;
    }
  }

  .react-datepicker__navigation--previous {
    left: 2rem;
    border-bottom: none;
    border-right: none;
  }

  .react-datepicker__navigation--next {
    &:not(.react-datepicker__navigation--next--with-time) {
      right: 2rem;
    }
    border-top: none;
    border-left: none;
  }

  .react-datepicker-popper[data-placement^="bottom"]
  .react-datepicker__triangle,
  .react-datepicker-popper[data-placement^="bottom"]
  .react-datepicker__triangle::before {
    border-bottom: 1px solid #fff;
  }

  .react-datepicker-popper[data-placement^="bottom"]
  .react-datepicker__triangle::before {
    border-bottom: 1px solid ${primeColor};
  }

  .react-datepicker-popper[data-placement^="top"]
  .react-datepicker__triangle::before,
  .react-datepicker__year-read-view--down-arrow::before,
  .react-datepicker__month-read-view--down-arrow::before,
  .react-datepicker__month-year-read-view--down-arrow::before {
    border-top-color: ${primeColor};
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    margin: 0 ${daySideMargin};
    width: ${dayWidth};
    line-height: 2.2857142857142856rem;
  }

  .react-datepicker__day-name {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: rgba(0, 0, 0, 0.38);
  }
  
  .react-datepicker__day-names {
    padding: 10px 12px;
  }
  
  .react-datepicker__day,
  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range {
    border-radius: 50%;
  }

  .react-datepicker__day {
    &:hover,
    &:focus {
      background-color: ${dayHover};
      outline: none;
    }
  }

  .react-datepicker__day--selected {
    background-color: ${primeColor};
    color: #fff;

    &:hover,
    &:focus {
      background-color: ${primeColor};
    }
  }

  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    border-radius: 0;
    background-color: #E7EFF6;
    color: #000;

    width: calc(${dayWidth} + 2 * ${daySideMargin});
    margin: 0;

    &.react-datepicker__day--selecting-range-start,
    &.react-datepicker__day--selecting-range-end,
    &.react-datepicker__day--range-start,
    &.react-datepicker__day--range-end {
      color: #fff;
      background-color: ${primeColor};
      width: calc(${dayWidth} + ${daySideMargin});
    }

    &.react-datepicker__day--selecting-range-start,
    &.react-datepicker__day--range-start {
      margin-left: ${daySideMargin};
    }

    &.react-datepicker__day--selecting-range-end,
    &.react-datepicker__day--range-end {
      margin-right: ${daySideMargin};
    }

    &.react-datepicker__day--selecting-range-start,
    &.react-datepicker__day--range-start,
    &:first-child {
      border-top-left-radius: 50%;
      border-bottom-left-radius: 50%;
    }

    &.react-datepicker__day--selecting-range-end,
    &.react-datepicker__day--range-end,
    &:last-child {
      border-top-right-radius: 50%;
      border-bottom-right-radius: 50%;
    }
  }

  .react-datepicker__day--keyboard-selected {
    background-color: #E7EFF6;
    color: #000;
  }

  .react-datepicker__day--disabled:not(.react-datepicker__day--selected) {
    color: #ccc;
    &:hover,
    &:focus {
      background-color: #fff;
      outline: none;
      color: #ccc;
    }
  }

  .react-datepicker__day--outside-month:not(.react-datepicker__day--disabled) {
    color: #777;
  }

  .react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item--selected {
    background-color: ${primeColor};
  }

  &.error input {
    background: #FFF6F6 !important;
    border-color: #E0B4B4 !important;
    color: #9F3A38 !important;
  }

  &.compact {
    .react-datepicker__close-icon::after {
      position: absolute;
      right: -0.42857142857142855rem;
    }

    &.disabled {
      &,
      &:hover {
        color: #808080;
        opacity: 1 !important;
      }

      input {
        &,
        &:hover {
          border-bottom-style: dashed !important;
          border-color: #aaa !important;
          color: rgba(0, 0, 0, 0.5);
          opacity: 1 !important;
        }
      }

      & > span svg path {
        fill: #808080;
      }
    }

    &.error {
      background: none !important;

      input {
        &,
        &:hover,
        &:focus {
          background: none !important;
          color: #990202 !important;
          border-color: #990202 !important;
          border-bottom-style: solid !important;
        }

        &::-moz-placeholder {
          color: #e7bdbc;
        }

        &::-webkit-input-placeholder {
          color: #e7bdbc;
        }

        &:-ms-input-placeholder {
          color: #e7bdbc;
        }

        &::-ms-input-placeholder {
          color: #e7bdbc;
        }

        &::placeholder {
          color: #e7bdbc;
        }
      }

      &.disabled input {
        &,
        &:hover,
        &:focus {
          border-bottom-style: dashed !important;
        }
      }

      & > span svg path {
        fill: #990202;
      }
    }

    & > span {
      right: 0;
    }

    input {
      border: none !important;
      border-radius: 0 !important;
      background: none;
      border-bottom: 1px solid #aaa !important;
      width: 100%;
      box-sizing: border-box !important;
      min-height: 2.0714285714285716rem !important;
      padding: 0.2857142857142857rem !important;
      font-size: 1rem !important;
      line-height: 1.3571428571428572rem !important;
      padding-right: 1rem !important;

      &:hover,
      &:focus {
        border-color: #135CA9 !important;
      }
    }

    .react-datepicker {
      border-radius: 0.2857142857142857rem;
    }
  }

  ${props => props.fluid && css`
    width: 100%;

    & input {
      width: 100%;
    }
  `}
  .react-datepicker__close-icon {
    &:before {
      position: absolute;
      background-repeat: no-repeat !important;
      width: 10px;
      height: 10px;
      content: '';
      background-image: url("data:image/svg+xml,%3Csvg width='8' height='9' viewBox='0 0 8 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect y='1.83336' width='1.88562' height='9.42809' rx='0.942809' transform='rotate(-45 0 1.83336)' fill='%2389ADD4'/%3E%3Crect x='6.66663' y='0.5' width='1.88562' height='9.42809' rx='0.942809' transform='rotate(45 6.66663 0.5)' fill='%2389ADD4'/%3E%3C/svg%3E%0A") !important;
    }
  }
`;

export const IconWrapper = styled.span`
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);

  // &:hover path {
    //     fill: ${primeColor};
  // }

  & > svg {
    display: block;
  }
`;


export const StyledRangeDatePicker = styled.div`
  width: 11.428571428571429rem;
`;



// WEBPACK FOOTER //
// ./App/components/DatePicker/DatePicker.styles.js